import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from '@mui/material';

export type EmptyConfirmAction = {
    label: string;
    onClick: () => void;
};

type EmptyConfirmDialogProps = {
    open: boolean;
    title?: string;
    message: React.ReactNode;
    /** Single primary confirm (default Yes). Ignored when confirmActions is set. */
    confirmText?: string;
    cancelText?: string;
    onConfirm?: () => void;
    onCancel: () => void;
    /**
     * Optional multi-confirm actions (e.g. Motor Vehicle / Taxi Cab).
     * When provided, replaces the single Yes button; cancel (No) still uses onCancel.
     */
    confirmActions?: EmptyConfirmAction[];
};

export default function EmptyConfirmDialog({
    open,
    title = 'Confirmation',
    message,
    confirmText = 'Yes',
    cancelText = 'No',
    onConfirm,
    onCancel,
    confirmActions,
}: EmptyConfirmDialogProps) {
    const hasMultiConfirm = Array.isArray(confirmActions) && confirmActions.length > 0;

    return (
        <Dialog open={open} onClose={onCancel}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent dividers>
                {typeof message === 'string' ? <Typography>{message}</Typography> : message}
            </DialogContent>
            <DialogActions>
                {hasMultiConfirm
                    ? confirmActions!.map((action) => (
                        <Button
                            key={action.label}
                            variant="contained"
                            onClick={action.onClick}
                        >
                            {action.label}
                        </Button>
                    ))
                    : (
                        <Button variant="contained" onClick={onConfirm}>
                            {confirmText}
                        </Button>
                    )}
                <Button variant="outlined" onClick={onCancel}>
                    {cancelText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
